import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { AuthenticationMethodType } from '../model';

@Injectable()
export class AuthenticationContextDatasourceService {
  private sessionId: string;
  private isSignature: boolean;
  private authMethodType: AuthenticationMethodType;
  private isSingleMethod: boolean;
  private idp: string;
  private clientInfo: any = null;
  private dateTime: string;

  public setContextData(queryParams: Params, params: Params = null) {
    if (!this.sessionId) {
      this.sessionId = queryParams['id'];
    }

    if (queryParams['sign']) {
      this.isSignature = queryParams['sign'] === 'true';
    }

    if (queryParams['authMethodType']) {
      this.authMethodType = AuthenticationMethodType[queryParams['authMethodType']];
    }

    if (queryParams['singleMethod']) {
      this.isSingleMethod = queryParams['singleMethod'] === 'true';
    }

    if (params && params['idp']) {
      this.idp = params['idp'];
    }

    if (!this.idp) {
      this.idp = 'Employee';
    }

    if (queryParams && queryParams['datetime']) {
      this.dateTime = queryParams['datetime'];
    }
  }

  public setSessionId(sessionId: string): string {
    this.sessionId = sessionId;
    return this.sessionId;
  }

  public setClientInfo(clientInfo: any) {
    this.clientInfo = clientInfo;
  }

  public getClientInfo() {
    return this.clientInfo;
  }

  public getSessionId(): string {
    return this.sessionId;
  }

  public getIsSignature(): boolean {
    return this.isSignature;
  }

  public getAuthMethodType(): AuthenticationMethodType {
    return this.authMethodType;
  }

  public getIsSingleMethod(): boolean {
    return this.isSingleMethod;
  }

  public getIdp(): string {
    return this.idp;
  }

  public getDateTime(): string {
    return decodeURIComponent(this.dateTime);
  }
}
